import { useMemo, useEffect, useState } from "react";
import styles from "./edit.module.scss";
import { useNavigate, useParams } from "react-router-dom";
import { TRANSMISSION_TYPES, TYPE_TYPES } from '../../../../constants/salePost';
import { MyPublicationEditProps } from '../../../../interfaces/pages';
import { addPointsInText, capitalize, formatInput, removePointsInText } from "../../../../helpers/app";
import { optionsAccidentsReported, optionsPersonalUse, optionsSoleOwner } from "../../../../constants/app";
import { Skeleton, Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import { YesNoTypes } from '../../../../interfaces/types';
import { COLORS, FUEL_TYPES } from "../../../../constants/Publication";
import ButtonShared from "../../../../components/Button/Button";
import ProfileCard from "../../../../components/ProfileCard";
import { VehiclePost } from '../../../../interfaces/publication';
import { myPubBrandEditBreadCrumb } from "../../../../constants/breadCrumbs";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import StepInfo from "../../../../components/BrandNewCar/StepInfo/StepInfo";
import StepPictures from "../../../../components/BrandNewCar/StepPictures/StepPictures";
import { useToast } from "../../../../helpers/hooks";
import { ImageFile } from '../../../../interfaces/salePost';

const DOORS_OPTIONS = [
  { value: "2", name: "2" },
  { value: "3", name: "3" },
  { value: "4", name: "4" },
  { value: "5", name: "5" },
  { value: "6", name: "6" },
];

const REGION_NAMES = [
  { id: 1, name: "Antofagasta" },
  { id: 2, name: "Arica y Parinacota" },
  { id: 3, name: "Atacama" },
  { id: 4, name: "Coquimbo" },
  { id: 5, name: "Región de Aisen del Gral. Carlos Ibañez del Campo" },
  { id: 6, name: "Región de la Araucania" },
  { id: 7, name: "Región de los lagos" },
  { id: 8, name: "Región de los rios" },
  { id: 9, name: "Región de Magallanes y de la Antartica Chilena" },
  { id: 10, name: "Región del Biobio" },
  { id: 11, name: "Región del libertador Gral. Bernardo O'Higgins" },
  { id: 12, name: "Región del Maule" },
  { id: 13, name: "Región Metropolitana de Santiago" },
  { id: 14, name: "Tarapaca" },
  { id: 15, name: "Valparaiso" }
];

const Edit = ({
  brands,
  getBrands,
  models,
  getModels,
  versions,
  getVersions,
  publication,
  getPublication,
  getArticlesFromPublication,
  setUploadImages,
  updateReducer,
  updatePublication,
  cleanAll,
  cleanUpdate,
  deletePublicationImage,
  postPublicationsImages,
  cleanImagesSaved,
  getMyPublicationsRequest,
  getYears,
  years,
  cleanGetYears,
  cleanGetModels = () => {},
  cleanGetBrands = () => {},
  cleanGetVersions = () => {},
  setIsNegotiate,
  getAdditionalCharacters,
  additionalCharacters,
  setAdditionalCharacters,
  user,
  adminBrand,
  getAdminBrand
}: MyPublicationEditProps) => {

  const toast = useToast();
  const navigate = useNavigate();
  const params = useParams();

  const [isNegotiatePrice, setIsNegotiatePrice] = useState<YesNoTypes>("SI");
  const [negotiatePercentage, setNegotiatePercentage] = useState<string>("10");
  const [negotiatePercentageError, setNegotiatePercentageError] = useState<string>("");


  const [expanded, setExpanded] = useState<string | false>('panel1');
  const [completedSteps, setCompletedSteps] = useState<string[]>([]);
  const [isStep1Valid, setIsStep1Valid] = useState(false);
  const [isStep2Valid, setIsStep2Valid] = useState(false);
  const [cantidadVersiones, setCantidadVersiones] = useState(1);
  const [hasMounted, setHasMounted] = useState(false);

  const [timeOutMessage, setTimeOutMessage] = useState<any>({ open: false, text: "" });
  const [loading, setLoading] = useState<boolean>(false);
  const [disabled, setDisabled] = useState<boolean>(false);
  const [selectedAdditionalCharacters, setSelectedAdditionalCharactersState] = useState<any[]>([]);

  const [typeSelected, setTypeSelected] = useState<any>({ value: "", error: "" });
  const [brandSelected, setBrandSelected] = useState<any>({ value: "", error: "" });
  const [yearSelected, setYearSelected] = useState<any>({ value: "", error: "" });
  const [transmissionSelected, setTransmissionSelected] = useState<any>({ value: "", error: "" });
  const [doorsSelected, setDoorsSelected] = useState<any>({ value: "", error: "" });
  const [regionSelected, setRegionSelected] = useState<any>({ value: "", error: "" });
  const [modelSelected, setModelSelected] = useState<any>({ value: "", error: "" });
  const [versionSelected, setVersionSelected] = useState<any>({ value: "", error: "" });
  const [colorSelected, setColorSelected] = useState<any>({ value: "", error: "" });
  const [fuelSelected, setFuelSelected] = useState<any>({ value: "", error: "" });
  const [mileage, setMileage] = useState<any>({ value: "", error: "" });
  const [accidentsReported, setAccidentsReported] = useState<any>({ value: "", error: "" });
  const [personalUse, setPersonalUse] = useState<any>({ value: "", error: "" });
  const [soleOwner, setSoleOwner] = useState<any>({ value: "", error: "" });
  const [vehicleVersions, setVehicleVersions] = useState<any[]>([]);

  const [imagesSelected, setImagesSelected] = useState<any[]>([]);
  const [confortsNormalized, setConfortsNormalized] = useState<any>();
  const [price, setPrice] = useState<any>({ value: "", error: "" });
  const [mainImage, setMainImage] = useState<any>(null);
  const isEditing = !!publication?.data;

  const mainImageId = mainImage?.id || null;
  const originalMainImageId = publication?.data?.pictures?.[0]?.id || null;

  const handleMainImageChange = (image: any) => {
    setMainImage(image ? {
      id: image.id,
      path: image.url || image.previewURL || image.path || ""
    } : null);
  };

  useEffect(() => {
    setHasMounted(true);
  }, []);
  
  const REGION_OPTIONS = useMemo(() => {
    return REGION_NAMES.map(region => ({
      name: region.name,
      value: region.name,
      label: region.name,
    }));
  }, [REGION_NAMES]);

  const setImages = (imgs: ImageFile[] | ((prev: ImageFile[]) => ImageFile[])) => {
    if (typeof imgs === 'function') {
      setImagesSelected(prev => imgs(prev));
    } else {
      setImagesSelected(imgs);
    }
  };

  const handleAccordionChange = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleVersionsChange = (cantidad: number) => {
    setCantidadVersiones(cantidad);
  };

  const mainImageChanged = !!mainImageId && mainImageId !== originalMainImageId;

  const isAllStepsValid = completedSteps.includes('panel1') &&
  vehicleVersions.length === cantidadVersiones &&
  vehicleVersions.every((_, i) => completedSteps.includes(`panel${i + 2}`));


  const handleDeleteVersion = (versionIndex: number) => {
    if (cantidadVersiones > 1) {
      setCantidadVersiones(prev => prev - 1);

      const panelToDelete = `panel${versionIndex + 2}`;
      if (expanded === panelToDelete) {
        if (versionIndex === 0) {
          setExpanded('panel2');
        } else {
          setExpanded('panel2');
        }
      }

      setCompletedSteps(prev => prev.filter(step => {
        const stepNumber = parseInt(step.replace('panel', ''));
        if (stepNumber === 1) return true;
        
        const versionNum = stepNumber - 1;
        return versionNum !== versionIndex + 1;
      }));
    }
  };

  const handleAddVersion = () => {
    const newVersionNumber = cantidadVersiones + 1;
    const newPanelId = `panel${newVersionNumber + 1}`;
    setCantidadVersiones(newVersionNumber);
    setExpanded(newPanelId);
  };
  
  const renderVersionAccordions = () => {
    if (!isEditing && !completedSteps.includes('panel1')) return null;

  
    return vehicleVersions.map((vehicle, i) => {
      const panelId = `panel${i + 2}`;
      const versionNumber = i + 1;
      const isFirstVersion = i === 0;
  
      return (
        <Accordion 
          key={vehicle._id || panelId}
          expanded={expanded === panelId}
          onChange={handleAccordionChange(panelId)}
          className={styles.accordion}
        >
          <AccordionSummary
            expandIcon={
              <span style={{ color: '#7100FF', fontSize: '15px', marginRight: '10px' }}>
                {expanded === panelId ? (
                  <span
                    style={{ color: isFirstVersion ? '#484848' : '#B3261E', fontSize: '14px', cursor: isFirstVersion ? 'default' : 'pointer' }}
                    onClick={!isFirstVersion ? (e) => { e.stopPropagation(); handleDeleteVersion(i); } : undefined}
                  >
                    {isFirstVersion || isEditing ? '' : 'Eliminar sección'}
                  </span>
                ) : 'Editar'}
              </span>
            }
            className={styles.accordionSummary}
          >
            <div className={styles.stepHeader}>
              {expanded !== panelId && (
                <span className={`${styles.stepNumber} ${completedSteps.includes(panelId) ? styles.completed : ''}`}>
                  {completedSteps.includes(panelId) && (
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M9 16.17L4.83 12L3.41 13.41L9 19L21 7L19.59 5.59L9 16.17Z" fill="currentColor"/>
                    </svg>
                  )}
                  Paso 2
                </span>
              )}
              <h3>Versión {versionNumber}</h3>
            </div>
          </AccordionSummary>
          <AccordionDetails>
            <StepPictures
            publication={publication}
              postPublicationsImages={postPublicationsImages}
              deletePublicationImage={deletePublicationImage}
              plate={""}
              isFoundPlate={false}
              fetchingDeleteImage=""
              cleanDeleteImage={() => {}}
              imagesVideos={Array.isArray(vehicle.images) ? vehicle.images : []}
              setImages={(imgs: any[]) => {
                const updated = [...vehicleVersions];
                updated[i].images = imgs;
                setVehicleVersions(updated);
              }}
              files={[]}
              versionIndex={i}
              setYear={() => {}}
              fuel={vehicle.fuel}
              version={{ id: vehicle._id, name: vehicle.version }}
              versions={[]} 
              getVersions={getVersions}
              getYears={getYears}
              years={years}
              cleanGetYears={cleanGetYears}
              fetchingVersions="unknown"
              cleanGetVersions={cleanGetVersions}
              getAdditionalCharacters={getAdditionalCharacters}
              additionalCharacters={additionalCharacters} 
              setSelectedAdditionalCharacters={(data) => {
                setSelectedAdditionalCharactersState(data);
                const updated = [...vehicleVersions];
                updated[i].additional_characters = data;
                setVehicleVersions(updated);
              }}
              selectedAdditionalCharacters={vehicle.additional_characters || []} 
              setAdditionalCharacters={(data) => {
                const updated = [...vehicleVersions];
                updated[i].additional_characters = data;
                setVehicleVersions(updated);
              }}
              setVersion={() => {}}
              setFuel={() => {}}
              year={vehicle.year}
              vehicleType={vehicle.type}
              setType={() => {}}
              transmission={vehicle.transmission}
              setTransmission={() => {}}
              setDoors={() => {}}
              doors={vehicle.doors}
              onValidityChange={(isValid: boolean) => setIsStep2Valid(isValid)}
              onContinue={(dataFromStep: any) => {
                const updated = [...vehicleVersions];
                updated[i] = {
                  ...updated[i],
                  ...dataFromStep
                };
                setVehicleVersions(updated);
              
                setCompletedSteps(prev => [...prev, panelId]);
                const nextPanel = `panel${i + 3}`;
                if (i + 1 < vehicleVersions.length) {
                  setExpanded(nextPanel);
                }else {
                  setExpanded(false);
                }
              }}
            />
          </AccordionDetails>
        </Accordion>
      );
    });
  };
  

  const updateDataPublication = () => {
    const originalVehicles = Array.isArray(publication?.data?.vehicles) ? publication.data.vehicles : [];
    const updatedArticles: any[] = [];

    originalVehicles.forEach((original: any, i: number) => {
      if (!original?._id) return;

      const panelId = `panel${i + 2}`;
      const updated = vehicleVersions[i];

      if (!updated || !completedSteps.includes(panelId)) return;

      const article: any = { _id: original._id };

      const updatedVersionName = typeof updated.version === 'object' ? updated.version?.name : updated.version;

      if (updatedVersionName !== original.version) {
        article.version = updatedVersionName;
      }
      if (updated.year !== original.year) {
        article.year = updated.year;
      }
      if (parseInt(removePointsInText(updated.price)) !== original.price) {
        article.price = parseInt(removePointsInText(updated.price));
      }
      if (updated.fuel !== original.fuel) {
        article.fuel = updated.fuel;
      }
      if (updated.transmission !== original.transmission) {
        article.transmission = updated.transmission;
      }
      if (updated.doors !== original.doors) {
        article.doors = updated.doors;
      }
      if (updated.type !== original.type) {
        article.type = updated.type;
      }

      const updatedPictures = Array.isArray(updated.pictures) ? updated.pictures : [];
      const originalImagesArray = Array.isArray(original.images) ? original.images : [];
      const originalPictures = originalImagesArray.map((img: any) => img.id || img._id);

      const picturesChanged = JSON.stringify(updatedPictures) !== JSON.stringify(originalPictures);
      if (picturesChanged) {
        article.pictures = updatedPictures.map((id: string) => ({ id }));
      }

      const updatedChars = updated.additional_characters || [];
      const originalChars = original.additional_characters || [];
      const charsChanged = JSON.stringify(updatedChars) !== JSON.stringify(originalChars);
      if (charsChanged) {
        article.additional_characters = updatedChars;
      }

      // Solo viajan los artículos con cambios reales.
      if (Object.keys(article).length > 1) {
        updatedArticles.push(article);
      }
    });

    if (updatedArticles.length === 0 && !mainImageChanged) {
      toast("No hiciste ninguna modificación.");
      setLoading(false);
      return;
    }

    const publicationId = params?.id;
    if (!publicationId) {
      setLoading(false);
      return;
    }

    const publicationObject: any = {};

    if (updatedArticles.length > 0) {
      publicationObject.article = updatedArticles;
    }

    if (mainImageChanged) {
      publicationObject.pictures = [mainImageId];
    }

    updatePublication(publicationId, publicationObject);
  };
  

  const handleSave = () => {
    let hasError = false;
    if (isNegotiatePrice === "SI" && (!negotiatePercentage || parseInt(negotiatePercentage) <= 0)) {
      setNegotiatePercentageError("Ingrese un porcentaje válido (1-100%)");
      hasError = true;
    }

    if (!mainImageId) {
      toast("Debes cargar una foto de portada.");
      hasError = true;
    }

    if (!hasError) {
      setLoading(true);
      updateDataPublication();
    }
  };


  useEffect(() => {
    if (!hasMounted) return; 
  
    if (updateReducer?.fetching === "success") {
      setLoading(false);
      cleanAll();
      cleanUpdate();
      getMyPublicationsRequest(1);
      return navigate(`/profile/my_publications_brand/${params?.id}/detail`);
    }
  }, [updateReducer?.fetching, hasMounted]);
  
  useEffect(() => {
    if (publication?.fetching === "success" && publication?.data?.vehicles?.length) {
      const versions = publication.data.vehicles.map((vehicle: any, index: number) => ({
        ...vehicle,
        images: vehicle.images.map((img: any, idx: number) => ({
          ...img,
          previewURL: img.path,
          index: idx,
          upload: "success",
          protected: idx < 5
        }))
      }));
  
      setVehicleVersions(versions);
      setCantidadVersiones(publication.data.vehicles.length);
      setCompletedSteps(prev => prev.includes('panel1') ? prev : [...prev, 'panel1']);
      }
  }, [publication?.fetching]);
  

  useEffect(() => {
    if (publication?.fetching === "success") {
      setImagesSelected(publication?.data?.pictures);
      setRegionSelected({ value: publication?.data?.region, error: "" });
      setPrice({ value: addPointsInText(publication?.data?.price), error: "" });
      setMileage({ value: addPointsInText(publication?.data?.secondary_description), error: "" });
      setAccidentsReported({ value: publication?.data?.record_edit?.accidents_reported, error: "" });
      setPersonalUse({ value: publication?.data?.record_edit?.personal_use, error: "" });
      setSoleOwner({ value: publication?.data?.record_edit?.sole_owner, error: "" });
      setIsNegotiatePrice(publication?.data?.detail_edit?.negotiate ? "SI" : "NO");
      setNegotiatePercentage(
        publication?.data?.detail_edit?.negotiate_percent !== undefined && publication?.data?.detail_edit?.negotiate_percent !== null
          ? publication.data.detail_edit.negotiate_percent.toString()
          : "0"
      );
      setSelectedAdditionalCharactersState(publication?.articles?.data?.additional_characters || []);
    }
  }, [publication?.fetching]);

  useEffect(() => {
    if (publication?.data?.pictures?.length) {
      const normalizedPictures = publication.data.pictures.map((picture: any, idx: number) => ({
        ...picture,
        previewURL: picture?.path || picture?.url || picture?.uri || "", 
        index: idx,
        upload: "success",
        protected: idx < 5
      }));

      setImagesSelected(normalizedPictures);

      const cover = publication.data.pictures[0];
      setMainImage(cover?.id ? { id: cover.id, path: cover.path || "" } : null);
    }
  }, [publication?.data?.pictures]);

  useEffect(() => {
    if (updateReducer?.fetching === "failure") {
      if (updateReducer?.error?.code === "PUBLICATION_IN_TRANSACTION") {
        toast("Error: La publicación está en transacción");
      } else {
        toast("Ha ocurrido un error");
      }
      setLoading(false);
      setTimeOutMessage({ ...timeOutMessage, open: false });
      cleanUpdate();
    }
    if (updateReducer?.fetching === "success") {
      toast("Publicación actualizada correctamente");
      setLoading(false);
      setTimeOutMessage({ ...timeOutMessage, open: false });
      cleanAll();
      getMyPublicationsRequest(1);
      return navigate(`/profile/my_publications_brand/${params?.id}/detail`);
    }
  }, [updateReducer?.fetching]);


  useEffect(() => {
    if (user?.profile?.code === "admin-brand" && adminBrand?.fetching === "unknown" && getAdminBrand) {
      (getAdminBrand as Function)();
    }
  }, [user?.profile?.code, adminBrand?.fetching, getAdminBrand]);

  return (
    <div className={styles.edit}>
      <ProfileCard breadCrumbs={myPubBrandEditBreadCrumb(params?.id, publication?.data?.title)}>
        <h1 className={styles.pageTitle}>Editar tu vehículo 0 km</h1>
        
        <div className={styles.sellModalContainer}>
          <div className={styles.accordionContainer}>
            {/* PASO 1: INFORMACIÓN GENERAL DEL VEHÍCULO */}
            <Accordion 
              expanded={expanded === 'panel1'} 
              onChange={handleAccordionChange('panel1')} 
              className={styles.accordion}
            >
              <AccordionSummary
                expandIcon={<span style={{ color: '#7100FF', fontSize: '15px', marginRight: '10px' }}>
                  {expanded === 'panel1' ? <span style={{ color: '#484848', fontSize: '18px' }}>1/2</span> : 'Editar'}
                </span>}
                className={styles.accordionSummary}
              >
                <div className={styles.stepHeader}>
                  {expanded !== 'panel1' && (
                    <span className={`${styles.stepNumber} ${completedSteps.includes('panel1') ? styles.completed : ''}`}>
                      {completedSteps.includes('panel1') && (
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M9 16.17L4.83 12L3.41 13.41L9 19L21 7L19.59 5.59L9 16.17Z" fill="currentColor"/>
                        </svg>
                      )}
                      Paso 1
                    </span>
                  )}
                  <h3>Información general del vehículo</h3>
                </div>
              </AccordionSummary>
              <AccordionDetails>
                <StepInfo
                publication={publication}
                  postPublicationsBrandImages={postPublicationsImages}
                  onMainImageChange={handleMainImageChange}
                  user={user}
                  adminBrand={adminBrand}
                  onValidityChange={(isValid: boolean) => setIsStep1Valid(isValid)}
                  onVersionsChange={handleVersionsChange}
                  cantidadVersiones={cantidadVersiones}
                  getModels={getModels}
                  cleanGetModels={cleanGetModels}
                  setModel={setModelSelected}
                  getBrands={getBrands}
                  cleanGetBrands={cleanGetBrands}
                  setBrand={setBrandSelected}
                  brands={brands}
                  models={models || { selected: null, fetching: 'idle', data: [] }}
                  onContinue={() => {
                    setCompletedSteps(prev => [...prev, 'panel1']);
                    setExpanded('panel2');
                  }}
                />
              </AccordionDetails>
            </Accordion>

            {renderVersionAccordions()}

            {completedSteps.includes('panel1') && 
              <div className={styles.bottomActions}>
               

                <ButtonShared
                  onPress={handleSave}
                  title={loading ? (
                    <span>
                      Guardando<span className={styles.dotOne}>.</span><span className={styles.dotTwo}>.</span><span className={styles.dotThree}>.</span>
                    </span>
                  ) : 'Guardar cambios'}
                  primary
                  className={styles.continueButton}
                  loading={loading}
                  disabled={ (!isAllStepsValid && !mainImageChanged) || publication?.data?.in_transaction || publication?.data?.reserved || disabled}
                />

                {(publication?.data?.in_transaction || publication?.data?.reserved) && (
                  <p className={styles.error}>La publicación está en transacción</p>
                )}
              </div>
            }
          </div>
        </div>
      </ProfileCard>
    </div>
  );
};

export default Edit;
